module.exports = __webpack_public_path__ + "img/image39.20e9f69c.png";